import React from 'react';
import { pricing } from '../data/content';
import { BookStack } from './BookStack';
import { CtaButton } from './CtaButton';
import { TrustRow } from './TrustRow';
export function FinalCta() {
  return <section className="bg-cream py-20 sm:py-24" aria-labelledby="final-title" data-id="element-74" data-mp="19f7g39ghulfh">
      <div className="mx-auto max-w-[880px] px-5 text-center sm:px-8" data-id="element-75" data-mp="15dlvf1xpx2uq">
        <h2 id="final-title" className="text-balance font-display text-[2.2rem] leading-[1.06] text-petrol sm:text-5xl" data-id="element-76" data-mp="15fgialsjv51g">
          Tu próxima sesión no tiene que <em className="text-terra" data-id="element-77" data-mp="1ed0kbwy8l5d4">empezar desde cero.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-ink-soft" data-id="element-78" data-mp="1t2okuvylfzzs">
          Ten a tu alcance un sistema organizado con 6 módulos especializados, +400 páginas de material profesional y 5
          bonos complementarios para consultar, adaptar y utilizar como apoyo en la preparación de tus sesiones.
        </p>

        <div className="mt-8" data-id="element-79" data-mp="1x5kx84xjizva">
          <BookStack variant="fullPack" className="max-w-[720px]" data-id="element-80" data-mp="1x6cr9bbhopjg" />
        </div>

        <p className="mt-6 text-sm font-semibold uppercase tracking-[0.18em] text-petrol" data-id="element-81" data-mp="n75m5roz2d34">
          6 módulos + +400 páginas + <span className="text-terra" data-id="element-82" data-mp="s6s0y5kg81e1">5 bonos gratis</span>
        </p>

        <div className="mx-auto mt-8 w-fit rounded-2xl bg-paper px-10 py-6 shadow-soft ring-1 ring-cream-line" data-id="element-83" data-mp="x2z9m648bqzo">
          <p className="font-display text-5xl text-petrol" style={{
          fontSize: "40px"
        }} data-id="element-84" data-mp="124g4nl018j8c">
            <span className="mr-2 text-2xl text-terra" data-id="element-85" data-mp="163xesrqem4ju">HOY:</span>
            {pricing.today}
          </p>
          <p className="mt-2 text-sm text-ink-mute" data-id="element-86" data-mp="1b1ytz1kpljq1">Pago único · Acceso inmediato · Acceso de por vida</p>
        </div>

        <div className="mt-8" data-id="element-87" data-mp="1fwcu1habgf11">
          <CtaButton checkout block data-id="element-88" data-mp="1ktwamnuhl3w5">
            Quiero acceder a Maestro de Sesiones
          </CtaButton>
        </div>
        <div className="mt-5" data-id="element-89" data-mp="1pth7msq3j268">
          <TrustRow items={['Pago seguro', 'Garantía de 7 días']} data-id="element-90" data-mp="1puaio5w38du6" />
        </div>
      </div>
    </section>;
}